import {
  Modal,
  Tag,
  Button,
  Badge,
} from 'antd'
import {CheckOutlined, ExclamationCircleOutlined, CloseOutlined} from '@ant-design/icons'
import React, { ReactElement, useState, useEffect } from 'react'
import styles from './ChooseBWXWModal.module.css'
import {saveAcupointAsync} from "../recipeListEditorSlice";
import {unwrapResult} from "@reduxjs/toolkit";
import {useDispatch} from "react-redux";
import {RootDispatch} from "../../../../app/store";
export interface saveAcupParams {
  acupointIdList?: string[]
  recipeItemId?: number
}
export const ChooseBWXWModal = (props: {
  recipeItemId?:number
  thisItemAcup?: any //当前明细的穴位数据（id数组）
  acupData?: any //所有穴位数据
  visible?: any
  onCancel: () => void
  onOk: (arg:saveAcupParams) => void
}): ReactElement => {
  const { acupData, thisItemAcup,recipeItemId } = props
  const dispatch = useDispatch<RootDispatch>()
  const [btnLoading, setBtnLoading] = useState(false) // 按钮loading控制

  const [activeFirstLevel, setActiveFirstLevel] = useState<string>('')
  const [activeSecondLevelName, setActiveSecondLevelName] = useState<string>('')
  const [selectedIds, setSelectedIds] = useState<string[]>([])

  const firstLevelList = acupData?.acupointList?.map((item: any) => item.acuName) || []
  firstLevelList.push('身体部位')

  // 根据 id 获取名称
  const getNameById = (id: string): string => {
    for (const firstItem of acupData?.acupointList || []) {
      for (const secondItem of firstItem?.child || []) {
        for (const thirdItem of secondItem?.child || []) {
          if (thirdItem.id == id) {
            return thirdItem.acuName
          }
        }
      }
    }
    for (const secondItem of acupData?.bodyList?.child || []) {
      for (const thirdItem of secondItem?.child || []) {
        if (thirdItem.id == id) {
          return thirdItem.acuName
        }
        for (const fourthItem of thirdItem?.child || []) {
          if (fourthItem.id == id) {
            return fourthItem.acuName
          }
        }
      }
    }
    return id
  }

  useEffect(() => {
    if (acupData && acupData.acupointList && acupData.acupointList.length > 0) {
      const firstLevel = acupData.acupointList[0]?.acuName
      if (firstLevel) {
        setActiveFirstLevel(firstLevel)
        const secondLevel = acupData.acupointList[0]?.child?.[0]?.acuName
        if (secondLevel) {
          setActiveSecondLevelName(secondLevel)
        }
      }
    }
  }, [acupData])

  // 从 thisItemAcup 初始化选中状态（id数组）
  useEffect(() => {
    let safeArray = [];
    try {
      safeArray = JSON.parse(thisItemAcup);
    } catch (e) {
      safeArray = [];
    }
    if (thisItemAcup && safeArray && Array.isArray(safeArray)) {
      setSelectedIds(safeArray)
    } else {
      setSelectedIds([])
    }
  }, [thisItemAcup])

  useEffect(() => {
    if (activeFirstLevel && activeFirstLevel !== '身体部位') {
      const secondLevelList = getSecondLevelList()
      if (secondLevelList.length > 0 && !activeSecondLevelName) {
        setActiveSecondLevelName(secondLevelList[0]?.acuName || '')
      }
    } else if (activeFirstLevel === '身体部位') {
      setActiveSecondLevelName('')
    }
  }, [activeFirstLevel])

  const handleFirstLevelClick = (name: string) => {
    setActiveFirstLevel(name)
    setActiveSecondLevelName('')
  }

  const getSecondLevelList = () => {
    if (activeFirstLevel === '身体部位') {
      return []
    }
    const firstItem = acupData?.acupointList?.find((item: any) => item.acuName === activeFirstLevel)
    return firstItem?.child || []
  }

  const handleSecondLevelClick = (acuName: string) => {
    setActiveSecondLevelName(acuName)
  }

  const getThirdLevelList = () => {
    if (activeFirstLevel === '身体部位') {
      return []
    }
    const secondLevelList = getSecondLevelList()
    const secondItem = secondLevelList.find((item: any) => item.acuName === activeSecondLevelName)
    return secondItem?.child || []
  }

  // 计算二级分类的选中数量
  const getItemCount = (acuName: string) => {
    if (activeFirstLevel === '身体部位') {
      return 0
    }
    const firstItem = acupData?.acupointList?.find((item: any) => item.acuName === activeFirstLevel)
    const secondItem = firstItem?.child?.find((item: any) => item.acuName === acuName)
    if (!secondItem?.child) return 0

    const selectedIdsStr = selectedIds.map(String)
    return secondItem.child.filter((item: any) => 
      selectedIdsStr.includes(String(item.id))
    ).length
  }

  // 处理点击选择
  const handleItemClick = (id: string) => {
    const idStr = String(id)
    const selectedIdsStr = selectedIds.map(String)
    if (selectedIdsStr.includes(idStr)) {
      setSelectedIds(selectedIds.filter(itemId => String(itemId) !== idStr))
    } else {
      setSelectedIds([...selectedIds, idStr])
    }
  }

  // 检查是否选中
  const isSelected = (id: string) => {
    const idStr = String(id)
    const selectedIdsStr = selectedIds.map(String)
    return selectedIdsStr.includes(idStr)
  }

  // 移除已选
  const removeSelectedItem = (id: string) => {
    const idStr = String(id)
    setSelectedIds(selectedIds.filter(itemId => String(itemId) !== idStr))
  }

  // 确定按钮点击
  const handleOk = () => {
    setBtnLoading(true)
    const params = {
      acupointIdList:selectedIds,
      recipeItemId:recipeItemId
    }
    //保存穴位
    dispatch(saveAcupointAsync(params))
      .then(unwrapResult)
      .then((res: any) => {
        props.onOk(params)
        setSelectedIds([]);
      }).catch((e) =>{
        return;
      }).finally(()=>{
        setBtnLoading(false);

     })

  }

  const renderBodyPartContent = () => {
    const bodyChild = acupData?.bodyList?.child || []
    return (
      <div className={styles.bodyPartContent}>
        {bodyChild.map((secondItem: any, secondIndex: number) => (
          <div key={`body-${secondIndex}-${secondItem.acuName}`} className={styles.bodySection}>
            <div className={styles.sectionTitle}>{secondItem.acuName}</div>
            <div className={styles.sectionItems}>
              {(secondItem?.child || []).map((thirdItem: any, thirdIndex: number) => {
                if (thirdItem?.child && thirdItem.child.length > 0) {
                  return thirdItem.child.map((item: any, itemIndex: number) => {
                    const id = item.id || `body-${secondIndex}-${thirdIndex}-${itemIndex}`
                    const textLength = item.acuName?.length || 0
                    const minWidth = 76 + Math.max(0, (textLength - 2)) * 14
                    return (
                      <span
                        key={id}
                        onClick={() => handleItemClick(id)}
                        className={`${styles.thirdLevelItem} ${isSelected(id) ? styles.selected : ''}`}
                        style={{
                          width: `${minWidth}px`,
                        }}
                      >
                        {item.acuName}
                        {isSelected(id) && (
                          <CheckOutlined className={styles.checkIcon} />
                        )}
                      </span>
                    )
                  })
                } else {
                  const id = thirdItem.id || `body-${secondIndex}-${thirdIndex}`
                  const textLength = thirdItem.acuName?.length || 0
                  const minWidth = 76 + Math.max(0, (textLength - 2)) * 14
                  return (
                    <span
                      key={id}
                      onClick={() => handleItemClick(id)}
                      className={`${styles.thirdLevelItem} ${isSelected(id) ? styles.selected : ''}`}
                      style={{
                        width: `${minWidth}px`,
                      }}
                    >
                      {thirdItem.acuName}
                      {isSelected(id) && (
                        <CheckOutlined className={styles.checkIcon} />
                      )}
                    </span>
                  )
                }
              })}
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <Modal
      title={'选择部位穴位'}
      visible={props?.visible}
      width={840}
      bodyStyle={{
        padding: '0',
        height: '550px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
      footer={
        <div className={styles.modalFooter}>
            <div className={styles.selectedTags}>
              <div className={styles.selectedLabel}>{selectedIds.length > 0 && '已选：' }</div>
              <div className={styles.selectedItems}>
                {selectedIds.length > 0 &&
                  selectedIds.map((id) => (
                      <Tag
                        key={id}
                        className={styles.selectedTag}
                      >
                        {getNameById(id)}
                        <span 
                          className={styles.closeIcon} 
                          onClick={() => removeSelectedItem(id)} 
                        >
                          <CloseOutlined style={{fontSize: 10}} color="#fff" />
                        </span>
                      </Tag>
                    ))
                }
              </div>
            </div>
          <div className={styles.modalButtons}>
            <Button onClick={props.onCancel}>取消</Button>
            <Button type="primary" onClick={handleOk} loading={btnLoading}>确定</Button>
          </div>
        </div>
      }
      confirmLoading={false}
      onCancel={(e) => {
        props?.onCancel && props?.onCancel()
      }}
      onOk={(e) => {
        handleOk()
      }}
    >
      <div className={styles.firstLevelTabs}>
        {firstLevelList.map((name: string, index: number) => (
          <span
            key={`first-${index}-${name}`}
            onClick={() => handleFirstLevelClick(name)}
            className={`${styles.firstLevelItem} ${activeFirstLevel === name ? styles.active : ''}`}
          >
            {name}
          </span>
        ))}
      </div>

      <div className={styles.contentWrapper}>
        {activeFirstLevel !== '身体部位' && (
          <div className={styles.secondLevelPanel}>
            {getSecondLevelList().map((item: any, index: number) => (
              <span
                key={`second-${index}-${item.acuName}`}
                onClick={() => handleSecondLevelClick(item.acuName)}
                className={`${styles.secondLevelItem} ${activeSecondLevelName === item.acuName ? styles.active : ''}`}
              >
                <Badge count={getItemCount(item.acuName)} size="small" color="#027AFF">
                  {item.acuName}
                </Badge>
              </span>
            ))}
          </div>
        )}

        <div className={`${styles.thirdLevelPanel} ${activeFirstLevel === '身体部位' ? styles.fullWidth : ''}`}>
          {activeFirstLevel === '身体部位' ? (
            renderBodyPartContent()
          ) : (
            <div className={styles.acupointContent}>
              {getThirdLevelList().map((item: any, index: number) => {
                const id = item.id || `acupoint-${index}`
                const textLength = item.acuName?.length || 0
                const minWidth = 76 + Math.max(0, (textLength - 2)) * 14
                return (
                  <span
                    key={id}
                    onClick={() => handleItemClick(id)}
                    className={`${styles.thirdLevelItem} ${isSelected(id) ? styles.selected : ''}`}
                    style={{
                      width: `${minWidth}px`,
                    }}
                  >
                    {item.acuName}
                    {isSelected(id) && (
                      <CheckOutlined className={styles.checkIcon} />
                    )}
                  </span>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}
